<div class="p-2 h-full">
  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
    @if (wellheadSlumpForm) {
      <form [formGroup]="wellheadSlumpForm">
        <div class="flex items-center mb-2">
          <p-checkbox size="small" inputId="applyDisplacement" formControlName="applyDisplacementToPostInstallLoads" binary="true" />
          <label for="applyDisplacement" class="ml-2"> Apply displacement to Post-Install loads</label>
        </div>
          
        <div class="flex flex-col mb-2">
          <label for="surfaceAmbientTemp">Wellhead Slump
            <i pTooltip="Upward Movement (+)  /  Downward Movement (-)" class="pi pi-info-circle cursor-help relative z-[2]"></i>
          </label>
          <app-validated-number-input
            [id]="'wellheadSlump'"
            [control]="wellheadSlumpControl"
            [value]="wellheadSlumpControl.value"
            [validation]="slumpValidation"
            [unit]="units.short"
          ></app-validated-number-input>
      </div>
    </form>
  }
 </app-tool-loader>
</div>